import Grid from "../../../config/Grid/Grid";
import IconButton from "../../IconButton/IconButton";
import useOnClickFunctions from "../helpers/onClickFunctions";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "../Drawer.module.scss";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";
import { isOrderingPath, orderPaths, parseTableScope } from "@/routes/paths";

interface DrawerLayoutProps {
  closeDrawer: () => void;
  title: string;
  children: React.ReactNode;
}

function DrawerLayout(props: DrawerLayoutProps) {
  const { closeDrawer, title, children } = props;
  const { handleClose } = useOnClickFunctions();
  const { restaurantId } = useParams();
  const location = useLocation();
  const lastPathElement = location.pathname.split("/").pop();
  const navigate = useNavigate();
  const { setVenuesData } = useVenuesDataStore();

  const handleCloseClick = () => {
    // Ordering has its own home: closing a checkout step returns to the cart,
    // not to the bill that handleClose() navigates to.
    if (isOrderingPath(location.pathname)) {
      const scope = parseTableScope(location.pathname);
      closeDrawer();
      if (scope) {
        navigate(orderPaths(scope.restaurantId, scope.tableId).cart);
      }
      return;
    }

    if (lastPathElement === "leave-tip") {
      setVenuesData({ tipAmount: 0 });
      navigate(`/restaurants/${restaurantId}/summary`);
    }
    closeDrawer();
    handleClose();
  };

  const handleGoBack = () => {
    closeDrawer();
    navigate(-1);
  };

  const displayBackButton =
    lastPathElement !== "extra-tip" && lastPathElement !== "leave-tip";

  return (
    <Grid>
      <div
        className={`start-1 col-4 align-start ${styles.drawerLayoutWrapper}`}
      >
        <div className={styles.drawerLayoutHeader}>
          {displayBackButton ? (
            <IconButton
              iconName="las la-angle-left icon-big"
              onClick={handleGoBack}
              color="primary"
              variant="text"
            />
          ) : (
            <IconButton
              iconName=""
              onClick={() => {}}
              color="primary"
              variant="text"
            />
          )}
          <p className={`body-bold-large ${styles.drawerLayoutTitle}`}>
            {title}
          </p>
          <IconButton
            iconName="las la-times icon-big"
            onClick={() => handleCloseClick()}
            color="primary"
            variant="text"
          />
        </div>
        {children}
      </div>
    </Grid>
  );
}

export default DrawerLayout;
